import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStore } from '../auth.store';
import { OrganizationStore } from '../domain/organization/organization-store';

export const periodEndedGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const authStore = inject(AuthStore);
  const orgStore = inject(OrganizationStore);

  await authStore.loadAuthState();
  await orgStore.settled();

  if (orgStore.periodEnded()) {
    return true;
  }
  return router.createUrlTree(['/portal']);
};
